// @flow
import React from 'react'
import Link from "gatsby-link"
import injectSheet from "react-jss"
import classNames from 'classnames'

import {styles} from './Styles/CTASection.Style'

type Props = {
  classes: { [string]: string }
}

class CTASection extends React.Component {
  props: Props

    render () {
      const {classes} = this.props

      return (
        <div className={classes.container}>
          <div className='container wrap'>
            <div className={classNames(classes.padding, 'row middle-xs')}>
              <div className='col-xs-12 center-xs col-sm-8 start-sm'>
                <p className={classes.paragraph}>
                  Get exclusive access to the platform for you and your team
                </p>
              </div>
              <div className='col-xs-12 center-xs col-sm end-sm'>
                <button className={classes.button + ' drift-open-chat'}
                  onClick={{/* TODO for JBR: add action to open the chat */}} >
                  Request access
                </button>
              </div>
            </div>
          </div>
        </div>
      )
    }
}

export default injectSheet(styles)(CTASection)



// WEBPACK FOOTER //
// ./src/layouts/CTASection.jsx